export interface BooleanReportParameter {
   value: boolean;
   isAskParameter?: boolean;
}

export const defaultFalseBooleanReportParameter: BooleanReportParameter = {
   isAskParameter: false,
   value: false,
};

export const defaultTrueBooleanReportParameter: BooleanReportParameter = {
   isAskParameter: false,
   value: true,
};
